import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * StockUpdate is now handled inline inside StockSearch.
 * This component redirects automatically.
 */
const StockUpdate = () => {
  const navigate = useNavigate();
  useEffect(() => { navigate("/stock/search", { replace: true }); }, [navigate]);
  return null;
};

export default StockUpdate;
